import { h, Host } from "@stencil/core";
export class NotificationItem {
    constructor() {
        this.subject = "";
        this.notificationUpdateError = false;
        this.notificationUpdateErrorText = "Update failed. Please try again.";
        this.link = "";
        this.linkText = "";
        this.type = "Detail";
        this.collapsed = true;
        this.tooLong = false;
    }
    baseClass = "ux-notification-text";
    /** The host html element. */
    el;
    setTooLong = () => {
        const wrapperDiv = this.el.querySelector(`div.${this.baseClass}__wrapper`);
        // @ts-expect-error Check for typing
        this.tooLong = wrapperDiv.scrollHeight > Math.round(wrapperDiv.getBoundingClientRect().height);
    };
    onContentChange() {
        this.setTooLong();
    }
    componentDidLoad() {
        this.setTooLong();
    }
    render() {
        const { baseClass, subject, link, linkText, type, notificationUpdateError, notificationUpdateErrorText } = this;
        const toggleCollapsed = (e) => {
            e.preventDefault();
            this.collapsed = !this.collapsed;
        };
        return (h(Host, { key: 'b610636cf57667b7658974d639805f2eae2c99a6' }, h("div", { key: 'b49caa631b1e01fd510a8c13b260a399f29e684d', class: baseClass }, h("div", { key: '45cbd1fa68bde728d09b4c6ddc9d2fa7a2e76483', class: {
                [`${baseClass}__wrapper`]: true,
                [`${baseClass}__wrapper_gradient`]: this.tooLong && this.collapsed,
                [`${baseClass}__wrapper_expanded`]: !this.collapsed
            } }, notificationUpdateError && (h("div", { key: 'd015c3a80f2d1ac858980b877bc07dd79f0a1922', class: `${baseClass}__error ux-text-normal` }, notificationUpdateErrorText)), type.toLowerCase() === "overview" && (h("div", { key: '4089717736d96d5a2d6fa784a27d8b2f666bb98c', class: `${baseClass}__subject ux-text-normal ux-text-normal--bold` }, subject)), type.toLowerCase() === "detail" && (h("div", { key: '19ee43f361da679fb9b0f05d608dfbbb408a4cc1', class: `${baseClass}__subject ux-text-title ux-text-title--bold` }, subject)), type.toLowerCase() === "overview" && (h("div", { key: 'f231a16c0132014a3d45144d9c46aea643d5752c', class: `${baseClass}__message ux-text-normal` }, h("slot", { key: '4ae8dd841ccc9e01bc57d2c22bbc270ae42133af', name: "message" }))), type.toLowerCase() === "detail" && (h("div", { key: '55c235aed35a59663878466013386de1f924f761', class: `${baseClass}__message ux-text-normal` }, h("slot", { key: '40d2a99afebfcf3250841d4363577fb73c712b10', name: "message" }), link && linkText && (h("a", { key: 'c22ee6954b420c13b3fcfe6390318965040e6c46', href: link, target: "_self", class: "ux-text-link ux-text-link--bold ux-text-link--green" }, linkText, h("ux-icon", { key: '25998b3f0a85aeb79f51f5ffc1b2e17cf5d38023', name: "arrow-right", weight: "normal" })))))), this.tooLong && (h("button", { key: '309f3ca17ccfa87ebf6251fbf2ae3964097dcdf2', class: "ux-icon-button", onClick: (e) => toggleCollapsed(e) }, h("ux-icon", { key: '6f540e35357b6bddb478b0aabbdaaced8de97aba', class: this.collapsed ? "" : `${baseClass}__icon`, "size-s": "15", name: "chevron-down" }))))));
    }
    static get is() { return "ux-notification-text"; }
    static get originalStyleUrls() {
        return {
            "$": ["notification-text.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["notification-text.css"]
        };
    }
    static get properties() {
        return {
            "subject": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The subject of the notification."
                },
                "attribute": "subject",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "notificationUpdateError": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Update notification state"
                },
                "attribute": "notification-update-error",
                "reflect": false,
                "defaultValue": "false"
            },
            "notificationUpdateErrorText": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Update notification error text"
                },
                "attribute": "notification-update-error-text",
                "reflect": false,
                "defaultValue": "\"Update failed. Please try again.\""
            },
            "link": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TrumpfNotificationActionLink[\"link\"]",
                    "resolved": "string",
                    "references": {
                        "TrumpfNotificationActionLink": {
                            "location": "import",
                            "path": "./notification-item",
                            "id": "src/components/notification-item/notification-item.tsx::TrumpfNotificationActionLink"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Link of the notification, e.g. link for read more button"
                },
                "attribute": "link",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "linkText": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TrumpfNotificationActionLink[\"linkText\"]",
                    "resolved": "string",
                    "references": {
                        "TrumpfNotificationActionLink": {
                            "location": "import",
                            "path": "./notification-item",
                            "id": "src/components/notification-item/notification-item.tsx::TrumpfNotificationActionLink"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Link text of the notification, e.g. read more"
                },
                "attribute": "link-text",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "type": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TrumpfNotificationType",
                    "resolved": "\"Detail\" | \"Overview\"",
                    "references": {
                        "TrumpfNotificationType": {
                            "location": "import",
                            "path": "./notification-item",
                            "id": "src/components/notification-item/notification-item.tsx::TrumpfNotificationType"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Type of notification. Can be 'Overview' or 'Detail'."
                },
                "attribute": "type",
                "reflect": false,
                "defaultValue": "\"Detail\""
            }
        };
    }
    static get states() {
        return {
            "collapsed": {},
            "tooLong": {}
        };
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "subject",
                "methodName": "onContentChange"
            }, {
                "propName": "message",
                "methodName": "onContentChange"
            }];
    }
}
//# sourceMappingURL=notification-text.js.map
